import { useTranslation } from 'react-i18next';

export default function ProductsHero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=modern%20LED%20lighting%20product%20catalog%20showroom%20bright%20white%20clean%20studio%20interior%20design%20architectural%20lighting%20fixtures%20display%20premium%20professional%20photography%20sophisticated%20minimal&width=1920&height=600&seq=prodheromain&orientation=landscape"
        alt="OKAYISU Products"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900/80 via-gray-900/50 to-transparent" />
      <div className="absolute inset-0 flex flex-col items-start justify-center px-6 md:px-20 max-w-7xl mx-auto left-0 right-0">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm border border-white/30 rounded-full px-4 py-1.5 mb-5">
          <span className="w-1.5 h-1.5 bg-amber-400 rounded-full" />
          <span className="text-white text-xs tracking-[0.2em] uppercase font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>{t('products.hero.badge')}</span>
        </div>
        <h1 className="text-white text-4xl md:text-6xl font-bold leading-tight mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
          {t('products.hero.heading1')}<br />
          <span className="text-amber-400">{t('products.hero.heading2')}</span>
        </h1>
        <p className="text-white/70 text-sm md:text-base max-w-lg leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{t('products.hero.desc')}</p>
      </div>
    </section>
  );
}